module.exports = __webpack_public_path__ + "static/media/qr.d5df7c9c.svg";